export function round(value: number, decimalPlaces = 2) {
  const inv = 10 ** decimalPlaces;

  return Math.round(value * inv) / inv;
}
